export const environment = {
  production: true,
  serviceUrl: 'https://api-v2.travelguidesfree.com/api',
  imageUrl: 'https://api-v2.travelguidesfree.com',
  // embedUrl: 'https://api.travelguidesfree.com'
  embedUrl: 'https://api-v2.travelguidesfree.com/api',
  appSourceUrl: 'https://app.travelguidesfree.com',
  mapsApiKey: 'AIzaSyCfdSvcZ_w1B_X5cdqVIT83bqhl5YKMgDs',
  websiteUrl: 'https://travelguidesfree.com'
};
